import "./utils/embedStorageIsolation";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { ENVIRONMENT_TYPE } from "./constant/common";
import { environment, initializeConfig } from "./constant/environment";
import "./constant/environment";
import { initializeSentry } from "./constant/sentryConfiguration";
import ContextProvider from "./context";
import { checkAndClearStorageIfNeeded } from "./hooks/localStorage";
import { ToastProvider } from "./utils/ToastProvider";
import { installActingPartnerInterceptor } from "./utils/actingPartner";
import { applyBrandingAtBoot } from "./utils/partnerBranding";
import { sanitizeStaleBookingSession } from "./utils/booking/sanitizeStaleBookingSession";
import { GoogleOAuthProvider } from '@react-oauth/google';
import AppErrorBoundary from "./component/reusableComponent/errorBoundary/AppErrorBoundary";


initializeConfig();
installActingPartnerInterceptor();
checkAndClearStorageIfNeeded();
sanitizeStaleBookingSession();

if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

applyBrandingAtBoot();

const deferSentry = () => {
  initializeSentry().catch(() => {});
};
if (typeof (window as any).requestIdleCallback === "function") {
  (window as any).requestIdleCallback(deferSentry, { timeout: 3000 });
} else {
  setTimeout(deferSentry, 0);
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  environment === ENVIRONMENT_TYPE.PRODUCTION ? (
    <AppErrorBoundary>
      <GoogleOAuthProvider clientId="411192459575-eoiroo0nqrht0mtfuh13p4tojof2i65r.apps.googleusercontent.com">
        <BrowserRouter>
          <ContextProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </ContextProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </AppErrorBoundary>
  ) : (
    <AppErrorBoundary>
      <GoogleOAuthProvider clientId="411192459575-eoiroo0nqrht0mtfuh13p4tojof2i65r.apps.googleusercontent.com">
        <BrowserRouter>
          <ContextProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </ContextProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </AppErrorBoundary>
  )
);